import { Alert, Box, Typography } from "@mui/material"
import type { FC } from "react"

import { formatRelativeTime } from "../utils"

import type { EntityLock } from "@/graphql/codegen/graphql"

interface EntityLockBannerProps {
  holder: EntityLock | null
  entityLabel?: string
}

export const EntityLockBanner: FC<EntityLockBannerProps> = ({ holder, entityLabel = "invoice" }) => (
  <Alert severity='warning'>
    <Typography data-testid='entity-lock.banner.title' className='text-sm'>
      {holder
        ? `This ${entityLabel} is currently being updated by another user. You may view it, but changes are temporarily unavailable.`
        : `Your edit session for this ${entityLabel} has expired. Refresh to check for updates before continuing.`}
    </Typography>
    {holder && (
      <Box className='mt-1'>
        <Typography data-testid='entity-lock.banner.holder-name' className='text-xs text-gray-700'>
          {`Locked by ${holder.lockedByUserName} · ${formatRelativeTime(holder.createdOn)}`}
        </Typography>
      </Box>
    )}
  </Alert>
)
